!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, t = {}, i = {}, s = e.parcelRequire5f74;
  null == s && ((s = function(e) {
    if (e in t) return t[e].exports;
    if (e in i) {
      var s = i[e];
      delete i[e];
      var r = {
        id: e,
        exports: {}
      };
      return t[e] = r, s.call(r.exports, r, r.exports), r.exports;
    }
    var l = new Error("Cannot find module '" + e + "'");
    throw l.code = "MODULE_NOT_FOUND", l;
  }).register = function(e, t) {
    i[e] = t;
  }, e.parcelRequire5f74 = s), (0, s.register)("cJzMp", function(e, t) {
    var i, s, r, l;
    i = e.exports, s = "createLogger", r = function() {
      return o;
    }, Object.defineProperty(i, s, {
      get: r,
      set: l,
      enumerable: !0,
      configurable: !0
    });
    const n = "mbf_debug", d = [ "lifecycle", "events", "network", "ui", "animation", "errors" ];
    function a() {
      const e = {};
      return d.forEach(t => e[t] = !0), {
        enabled: !1,
        categories: e,
        files: {}
      };
    }
    "undefined" != typeof window && function() {
      try {
        const e = localStorage.getItem(n);
        if (!e) return a();
        const t = JSON.parse(e), i = a();
        return i.enabled = !!t.enabled, t.categories && "object" == typeof t.categories && Object.keys(i.categories).forEach(e => {
          e in t.categories && (i.categories[e] = !!t.categories[e]);
        }), t.files && "object" == typeof t.files && (i.files = t.files), i;
      } catch {
        return a();
      }
    }();
    const o = () => () => {};
  });
  var r = s("cJzMp");
  customElements.get("slider-controls") || customElements.define("slider-controls", class extends HTMLElement {
    static get observedAttributes() {
      return [ "data-slider-target", "data-slider-targets" ];
    }
    constructor() {
      super(), this._rawLogger = (0, r.createLogger)("slider-controls"), this.isDebugLogEnabled = !1, 
      this.slider = null, this.sliders = [], this.sliderStates = new WeakMap, this.prev = null, 
      this.next = null, this._activityObserver = null, this._onPrevClick = this._onPrevClick.bind(this), 
      this._onNextClick = this._onNextClick.bind(this), this._onSliderState = this._onSliderState.bind(this), 
      this._onRefresh = this._onRefresh.bind(this);
    }
    log(e, t, i) {
      this.isDebugLogEnabled && this._rawLogger(e, t, i);
    }
    connectedCallback() {
      this.isDebugLogEnabled = this.hasAttribute("data-debug-enabled"), this.prev = this.querySelector("[data-previous]"), 
      this.next = this.querySelector("[data-next]"), this.log("lifecycle", "connected", {
        sliderTarget: this.dataset.sliderTarget || null,
        sliderTargets: this.dataset.sliderTargets || null
      }), this.prev?.addEventListener("click", this._onPrevClick), this.next?.addEventListener("click", this._onNextClick), 
      this.addEventListener("slider-controls:refresh", this._onRefresh), this._bindTargetSliders();
    }
    disconnectedCallback() {
      this.prev?.removeEventListener("click", this._onPrevClick), this.next?.removeEventListener("click", this._onNextClick), 
      this.removeEventListener("slider-controls:refresh", this._onRefresh), this._unbindTargetSliders();
    }
    _onPrevClick() {
      const e = this._getActiveSlider();
      e && (this.log("events", "previous click", {
        activeSlider: e.dataset.sliderId || null
      }), e.dispatchEvent(new CustomEvent("slider:previous")));
    }
    _onNextClick() {
      const e = this._getActiveSlider();
      e && (this.log("events", "next click", {
        activeSlider: e.dataset.sliderId || null
      }), e.dispatchEvent(new CustomEvent("slider:next")));
    }
    _onSliderState(e) {
      const t = e.currentTarget, i = e.detail || {};
      this.sliderStates.set(t, i), this.log("events", "slider state event", {
        sourceSlider: t?.dataset?.sliderId || null,
        controlsVisible: i.controlsVisible,
        canGoPrev: i.canGoPrev,
        canGoNext: i.canGoNext
      }), t === this._getActiveSlider() && this._applyState(i);
    }
    _onRefresh() {
      this._bindTargetSliders();
    }
    refreshState() {
      this._syncActiveSliderState();
    }
    _applyState(e = {}) {
      let t = !0 === e.controlsVisible;
      const i = t && !0 === e.canGoPrev, s = t && !0 === e.canGoNext;
      i || s || (t = !1), this.log("ui", "apply controls state", {
        activeSlider: this.slider?.dataset?.sliderId || null,
        controlsVisible: t,
        canGoPrev: i,
        canGoNext: s
      });
      const r = (e, t) => {
        if (!e) return;
        const i = t ? "false" : "true";
        e.getAttribute("aria-hidden") !== i && e.setAttribute("aria-hidden", i);
      };
      r(this, t), this.prev && (this.prev.hasAttribute("disabled") === i && this.prev.toggleAttribute("disabled", !i), 
      r(this.prev, i)), this.next && (this.next.hasAttribute("disabled") === s && this.next.toggleAttribute("disabled", !s), 
      r(this.next, s));
    }
    _bindTargetSliders() {
      this._unbindTargetSliders(), this.sliders = this._resolveTargetSliders(), this.log("lifecycle", "bind target sliders", {
        count: this.sliders.length,
        ids: this.sliders.map(e => e.dataset.sliderId || null)
      }), this.sliders.length ? (this.sliders.forEach(e => {
        e.addEventListener("slider:init", this._onSliderState), e.addEventListener("slider:change", this._onSliderState), 
        e.addEventListener("slider:controls-state", this._onSliderState);
      }), this._syncActiveSliderState()) : this._applyState();
    }
    _unbindTargetSliders() {
      this.sliders.forEach(e => {
        e.removeEventListener("slider:init", this._onSliderState), e.removeEventListener("slider:change", this._onSliderState), 
        e.removeEventListener("slider:controls-state", this._onSliderState);
      }), this.sliders = [], this.slider = null, this._applyState();
    }
    _resolveTargetSliders() {
      const e = this.closest(".shopify-section") || document, t = (this.dataset.sliderTargets || "").split(",").map(e => e.trim()).filter(Boolean);
      if (t.length) return t.map(t => e.querySelector(`slider-component[data-slider-id="${t}"]`)).filter(Boolean);
      const i = this.dataset.sliderTarget;
      if (i) {
        const t = e.querySelector(`slider-component[data-slider-id="${i}"]`);
        return t ? [ t ] : [];
      }
      const s = this.closest("slider-component");
      return s ? [ s ] : [];
    }
    _getActiveSlider() {
      if (!this.sliders.length) return null;
      if (this.dataset.sliderTarget) return this.sliders.find(e => e.dataset.sliderId === this.dataset.sliderTarget) || this.sliders[0];
      const e = this.sliders.find(e => "true" === e.dataset.rpActiveSlider);
      return e || (this.sliders.find(e => {
        const t = e.closest("[data-rp-panel]");
        return !t || "true" !== t.getAttribute("aria-hidden");
      }) || this.sliders[0]);
    }
    _syncActiveSliderState() {
      if (this.slider = this._getActiveSlider(), this.log("lifecycle", "sync active slider", {
        activeSlider: this.slider?.dataset?.sliderId || null,
        available: this.sliders.map(e => e.dataset.sliderId || null)
      }), !this.slider) return void this._applyState();
      const e = this.sliderStates.get(this.slider);
      e && this._applyState(e);
      const t = this.slider;
      t.dispatchEvent(new CustomEvent("slider:get-state", {
        detail: {
          callback: e => {
            const i = e || {};
            this.sliderStates.set(t, i), this.slider === t && this._applyState(i);
          }
        }
      }));
    }
  });
}();